import { Action } from '@ngrx/store';

export enum PatientDataActionTypes {
  UPDATE_PATIENT_DATA_IN_STORE = '[Bpmn Process] Update patient data in store'
}

export class UpdatePatientDataInStoreAction implements Action {
  readonly type = PatientDataActionTypes.UPDATE_PATIENT_DATA_IN_STORE;
  constructor(public payload: { patientData: any}) { }
}
